export const ESTIMATE_TOOLTIP_TEXT =
  'Our TopEstimate uses AI to estimate home value. This is a reference point only. Speak with a realtor for better insight into potential value of property.';
export const OFFER_TOOLTIP_TEXT =
  'Offer information obtained from listing broker';
